import { FormattedMessage } from 'react-intl';
import { Link } from '../../types';
import styles from './FooterLink.module.scss';

export type FooterLinkProps = {
  link: Link;
  onClick?: (e: React.MouseEvent) => void;
};

export const FooterLink: React.FC<FooterLinkProps> = ({ link, onClick }) => {
  return (
    <a className={styles.footerLink} href={link.link} onClick={onClick}>
      <FormattedMessage {...link.text} />
    </a>
  );
};
